export const D2D_STATUSES = [
  "NEW",
  "ACCEPTED",
  "REJECTED",
  "EXPIRED",
  "SHIPPED",
  "COMPLETED",
  "CREDITED",
] as const;

export type D2DStatus = (typeof D2D_STATUSES)[number];

export const D2D_STATUS_FILTER_OPTIONS = [
  "NEW",
  "ACCEPTED",
  "D2D_CLAIMED",
  "MANUAL_REJECTED",
  "EXPIRED",
  "SHIPPED",
  "COMPLETED",
  "CREDITED",
] as const;
export type D2DStatusFilterOption = (typeof D2D_STATUS_FILTER_OPTIONS)[number];

export interface D2DRequestRow {
  id: string;
  orderNumber: string;
  dealerReference: string;
  partNumber: string;
  requestedQuantity: number;
  acceptedQuantity: number;
  dateRequested: string;
  timeToRespond: string;
  status: D2DStatus;
  lastChangedBy: string;
}

export interface D2DRequestsRowForModal {
  id: string;
  orderNumber: string;
  status: D2DStatus;
}
